/**
 * Эндпоинты для работы с уведомлениями (notifications)
 */
export const NOTIFICATION_ENDPOINTS = {
  /** GET /v1/users/{userId}/notifications - Получение списка уведомлений пользователя */
  getUserNotifications: (userId: string) => `/v1/users/${userId}/notifications`,

  /** PATCH /v1/notifications - Отметить уведомления как прочитанные */
  markAsWatched: "/v1/notifications",
} as const;
